import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./View.module.sass";
import Table from "../Table";
import { get_all_permitted_roles } from "../../../../../../API/RBAC";
import Card from "../../../../../../components/Card";
import { useNavigate } from "react-router";
import Panel from "./Panel/index";
import { message } from "antd";

const View = () => {
  const [visible, setVisible] = useState(false);
  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();

  const handleCreateRole = () => {
    navigate("/settingsDashboard/accessControl/roles/create");
  };

  const fetchAllRoles = async () => {
    try {
      const res = await get_all_permitted_roles();
      if (res && res.data) {
        setRoles(res.data);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      message.error("Failed to fetch roles");
    }
  };

  useEffect(() => {
    fetchAllRoles();
  }, []);

  return (
    <>
    <div className="mb-[15%]">
      <Card
        className={cn(styles.card)}
        title="Manage Roles"
        classTitle="title-green"
      >
        <div className={styles.list}>
          <Table
            data={roles}
            className={styles.table}
            activeTable={visible}
            setActiveTable={setVisible}
          />
        </div>
      </Card>
      </div>
      <div className="fixed bottom-7 left-30 right-5">
        <Panel handleCreateRole={handleCreateRole} />
      </div>
    </>
  );
};

export default View;
